import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoggerVariables } from 'app/logger/logger.common';
import { MetadataMode } from 'shell-models-lib';
export { MetadataMode } from 'shell-models-lib';

@Injectable({
    providedIn: 'root'
})
export class MetadataModeService {
    public metadataMode$: Observable<MetadataMode>;
    public isMetadataModeReady$ = new BehaviorSubject<boolean>(false);
    private _metadataMode$: BehaviorSubject<MetadataMode>;

    constructor() {
        this._metadataMode$ = new BehaviorSubject<MetadataMode>(MetadataMode.Git);
        this.metadataMode$ = this._metadataMode$;
        this._metadataMode$.subscribe((mode: MetadataMode) => {
            LoggerVariables.isGitMode.next(mode === MetadataMode.Git);
        });
    }

    public isGitMode(): boolean {
        return this._metadataMode$.value === MetadataMode.Git;
    }

    public isLiveMode(): boolean {
        return this._metadataMode$.value === MetadataMode.Live;
    }

    public setLiveMode(): void {
        if (this._metadataMode$.value !== MetadataMode.Live) {
            this._metadataMode$.next(MetadataMode.Live);
        }
        this.isMetadataModeReady$.next(true);
    }

    public getCurrentMode(): MetadataMode {
        return this._metadataMode$.value;
    }

    public setGitMode(): void {
        if (this._metadataMode$.value !== MetadataMode.Git) {
            this._metadataMode$.next(MetadataMode.Git);
        }
        this.isMetadataModeReady$.next(true);
    }
}
